module.exports = __webpack_public_path__ + "media/video_smartphone_3_de.be01b7e2.mp4";